import type { AfterResponseHook } from 'ky';

export const CONSULTANT_NOT_ACTIVE_PARTNER_CODE = 'CONSULTANT_NOT_ACTIVE_PARTNER';
export const CONSULTANT_NOT_ACTIVE_PARTNER_EVENT = 'prospero:consultant-not-active-partner';

export function isConsultantNotActivePartnerBody(body: unknown): boolean {
  return (
    typeof body === 'object' &&
    body !== null &&
    'code' in body &&
    body.code === CONSULTANT_NOT_ACTIVE_PARTNER_CODE
  );
}

async function hasNotActivePartnerCode(response: Response): Promise<boolean> {
  try {
    return isConsultantNotActivePartnerBody(await response.clone().json());
  } catch {
    return false;
  }
}

/**
 * A Consulente who is no longer a designated consultant of an active partner
 * gets 403 CONSULTANT_NOT_ACTIVE_PARTNER on every tenant-scoped call. The ky
 * layer only announces it on `window`; the shell shows the blocking message
 * (see `ConsultantNotActivePartnerDialog`), so services stay UI-free.
 */
export const notifyConsultantNotActivePartnerHook: AfterResponseHook = async ({ response }) => {
  if (response.status === 403 && (await hasNotActivePartnerCode(response))) {
    window.dispatchEvent(new CustomEvent(CONSULTANT_NOT_ACTIVE_PARTNER_EVENT));
  }
  return response;
};
